import { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "@/components/icon";
import { getLastStudied } from "@/utils/lastStudied";
import Image from "@/components/image";
import { ELEMENT_TYPES } from "@/features/analytics";

// Subtle dotted pattern (primary tint, very low opacity).
const PATTERN_STYLE = {
  backgroundImage:
    "radial-gradient(rgba(100, 97, 255, 0.12) 1px, transparent 1px)",
  backgroundSize: "14px 14px",
} as const;

export default function ContinueStudy() {
  const [record] = useState(() => getLastStudied());

  if (!record) return null;

  const { courseId, lessonId, miniAppUuid, courseTitle, lessonTitle } = record;
  const resumeHref = `/course/${courseId}/lesson/${lessonId}?miniAppUuid=${encodeURIComponent(miniAppUuid)}`;

  const progress =
    typeof record.progressPercentage === "number"
      ? Math.max(0, Math.min(100, Math.round(record.progressPercentage)))
      : null;

  return (
    <section className="px-4 pt-4" data-track-section="continue_study">
      <Link
        to={resumeHref}
        className="relative block overflow-hidden rounded-2xl border border-default-200 bg-background p-3"
        data-track-type={ELEMENT_TYPES.resumeCard}
        data-track-id={courseId}
        data-track-target="course"
      >
        <div
          className="pointer-events-none absolute inset-0"
          style={PATTERN_STYLE}
        />
        <div className="pointer-events-none absolute -left-10 -top-14 size-36 rounded-full bg-primary/5 blur-2xl" />

        <div className="relative flex items-center gap-3">
          <div className="size-16 shrink-0 overflow-hidden rounded-xl bg-default-100 ring-1 ring-default-200">
            {record.coverUrl ? (
              <Image
                src={record.coverUrl}
                alt={courseTitle}
                width={64}
                height={64}
                className="size-full object-cover"
              />
            ) : null}
          </div>

          <div className="min-w-0 flex-1">
            <p className="mt-2 truncate text-[15px] font-bold leading-snug text-default-900">
              {courseTitle}
            </p>
            {lessonTitle ? (
              <p className="truncate text-xs text-default-500">{lessonTitle}</p>
            ) : null}
          </div>

          <span className="flex p-1.5 pr-3 shrink-0 text-xxs font-bold items-center justify-center rounded-lg bg-warning text-white">
            ادامه مطالعه
            <Icon name="chevron-left" size={14} />

          </span>

        </div>

        {progress !== null ? (
          <div className="relative mt-4">
            <div className="mb-1.5 flex items-center justify-between text-[11px] font-medium">
              <span className="text-default-500">پیشرفت دوره</span>
              <span className="font-bold text-primary">
                {progress.toLocaleString("fa-IR")}٪
              </span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-default-100">
              <div
                className="h-full rounded-full bg-primary transition-[width] duration-500"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        ) : null}
      </Link>
    </section>
  );
}
